<template>
	<v-row justify="center">
    <LeadDetails 
      @closeDialog="closeLeadDialog"  
      :dialog="leadDialog"
      :lead="selectedLead"/>
    <v-dialog
    fullscreen
    hide-overlay 
    v-if="dialog"
    v-model.sync="sDialog"
    >
      <v-card>
        <v-toolbar>
          <v-btn icon @click="sDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Leads da segmentação</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
        	<v-data-table
			      :headers="headers"
			      :items="$store.state.leadSegmentationLeads"
			      hide-default-footer
			      class="elevation-1"      
			      :footer-props="{
			        showFirstLastPage: true,
			        firstIcon: 'mdi-arrow-collapse-left',
			        lastIcon: 'mdi-arrow-collapse-right',
			        prevIcon: 'mdi-minus',
			        nextIcon: 'mdi-plus',        
			      }"                
			    >      
			      <template v-slot:body="{ items }">
			        <tbody>
			          <tr v-for="item in items" :key="item.id">
			            <td>{{item.name}}</td>
			            <td>{{item.email}}</td>
			            <td>
			              <v-btn fab small color="secondary" @click="() => showLeadDialog(item)">
			                <v-icon>search</v-icon>
			              </v-btn>
			            </td>
			          </tr>
			        </tbody>
			      </template>
			    </v-data-table>    
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import LeadDetails from '../Leads/Details.vue'
export default {
  components: {
    LeadDetails
  },
  name: 'Leads',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    showLeadDialog(lead) {
      this.selectedLead = lead
      this.leadDialog = true
    },
    closeLeadDialog() {
      this.leadDialog = false
    }
  },
  computed: {
    sDialog: {
      get() {
        return this.dialog;
      },
      set(value) {          
        this.$emit('closeDialog');
      }
    },
  },
  data () {
    return {
      selectedLead: null,
      leadDialog: false,
      headers: [
        {text: 'Nome', value: 'name'},
        {text: 'Email', value: 'email'},
        {text: '', value: ''},
      ],
    }
  }
}
</script>

<style lang="css" scoped>
</style>